<template>
  <div
    class="m-search-filter-bar"
  >
    <div class="filter-bar-container">
      <div class="filter-bar-wrapper">
        <a
          v-if="skipToContentId"
          class="_screenreader-action"
          :href="`#${skipToContentId}`"
        >
          {{ i18n[locale].skipToContent }}
        </a>
        <div class="m-filters">
          <slot />
        </div>
        <div :class="['search-reset', { invisible: !showReset}]">
          <button
            class="reset -active"
            @click="reset"
          >
            <span v-html="resetLabel" />
            <i class="icon-revert" />
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import enTranslations from './../../../i18n/en_CA/filter-bar.json'
import frTranslations from './../../../i18n/fr_CA/filter-bar.json'

export default {
  name: 'SearchFilterBar',
  props: {
    resetLabel: {
      type: String,
      default: 'Reset filters'
    },
    showReset: {
      type: Boolean,
      required: false
    },
    locale: {
      type: String,
      default: 'en'
    },
    skipToContentId: {
      type: String,
      default: undefined
    }
  },
  data () {
    return {
      i18n: {
        en: enTranslations,
        fr: frTranslations
      }
    }
  },
  methods: {
    reset () {
      this.$emit('onReset')
    }
  }
}
</script>

<style lang="less">
@import "./../../../less/accessibility.less";
@import (reference) "./../../../less/shared/utilities.less";
@import "@{frontend_static_less}/public/modules/m-search-filter-bar.less";
</style>
